<template lang="pug">
.onboarding
  .onboarding-steps
    component(:is="currentStep", @next="nextStep", @finished="completeOnboarding")


  .onboarding-step-tracker
    .onboarding-step-tracker-dot(v-for="blah, i in steps", :class="{selected: step === i}", @click="step = i")
</template>

<script>

import OnboardingInvite from '@/components/onboarding/OnboardingInvite'
import OnboardingBoardCreate from '@/components/onboarding/OnboardingBoardCreate'
import OnboardingPostCreate from '@/components/onboarding/OnboardingPostCreate'
import OnboardingCongratulations from '@/components/onboarding/OnboardingCongratulations'

const steps = [
  OnboardingBoardCreate,
  OnboardingPostCreate,
  OnboardingInvite,
  OnboardingCongratulations
]

export default {
  name: 'OnboardingTutorial',
  data () {
    return {
      step: 0,
      steps
    }
  },
  mounted () {

  },
  computed: {
    currentStep () {
      return this.steps[this.step]
    }
  },
  methods: {
    nextStep () {
      this.step = this.step + 1
    },
    completeOnboarding () {
      this.$router.push({ name: 'AdminDashboard' })
    }
  },
  watch: {
  }
}
</script>

<style scoped lang="stylus">
.onboarding
  margin $spacing-4 auto 0
  width 846px
  +for_breakpoint(mobile)
    width auto

.onboarding-step-tracker
  display flex
  padding 15px
  justify-content center
  .onboarding-step-tracker-dot
    background-color $background-color-2
    border-radius 100%
    height 15px
    margin 0 5px
    width 15px
    &.selected
      background-color $color-primary

</style>
